
import Vue from 'vue';

import {
  PipelineValidationMonitor,
  OutOfBoundariesMonitor,
  ProductNotPrintableMonitor,
  SmallDetailsMonitor,
} from './index';

// import SmallDetailsMonitor from './SmallDetailsMonitor.vue';

export default Vue.extend({
  name: 'SystemMonitor',
  components: {
    PipelineValidationMonitor,
    OutOfBoundariesMonitor,
    ProductNotPrintableMonitor,
    SmallDetailsMonitor,
  },
});
